import { useTranslation } from "react-i18next";
import { HiOutlineLink } from "react-icons/hi2";

import FeaturedIcon from "@/components/atoms/FeaturedIcon";
import BasicModalContent from "@/components/atoms/modal-panels/BasicModalContent";
import AllCRMGrid from "@/components/organisms/crm/AllCRMGrid";

type Props = {
  onClose: (value: boolean) => void;
  preventClose?: boolean;
  listId?: string;
  listName?: string;
};

const CRMModal = ({ onClose, preventClose = false, listId, listName }: Props) => {
  const { t } = useTranslation();

  return (
    <BasicModalContent
      featuredIcon={<FeaturedIcon icon={HiOutlineLink} size={"lg"} color={"primary"} />}
      heading={t("crm.connections.heading")}
      preventClose={preventClose}
      body={t("crm.connections.description")}
      onClose={onClose}
      data-testid={"manage-crm-modal"}
    >
      <AllCRMGrid
        className={"grid grid-cols-2 gap-6"}
        listId={listId}
        listName={listName}
        onClose={() => onClose(true)}
      />
    </BasicModalContent>
  );
};

export default CRMModal;
